import messages from '../constants/logMessages.json';
import { AnalyticsDataObject, LoseObject } from '../types/configs';
import logging, { getMessage } from '../utils/logging';

interface CacheHelper {
  set(data: AnalyticsDataObject, key: string): CacheHelper;
  get(): LoseObject;
  getCacheItem(key: string): AnalyticsDataObject | null;
  removeCacheItem(): CacheHelper;
  clear(): void;
}

const { infoHeading, infoBold } = messages;

export default (storage: Storage | false): CacheHelper => {
  const storageKey = '__qbe_analytics_queue';

  let cache: LoseObject = {};

  const saveToStorage = () => {
    if (storage && typeof window !== 'undefined') {
      storage.setItem(storageKey, JSON.stringify(cache));
    }
  };

  const cacheHelper: CacheHelper = {
    set: (data: AnalyticsDataObject, key: string): CacheHelper => {
      if (!data || !key) {
        logging.info(getMessage('cacheSetRequiresKey'), infoHeading, infoBold);
        return cacheHelper;
      }

      if (!cache[storageKey]) {
        cache[storageKey] = {
          [key]: [],
        };
      }

      if (storage && typeof window !== 'undefined') {
        if (Array.isArray(cache[storageKey][key])) {
          cache[storageKey][key].push(data);
          saveToStorage();
        }
      }

      return cacheHelper;
    },
    get: (): LoseObject => cache,
    getCacheItem: (key: string): AnalyticsDataObject | null => {
      if (!key) {
        logging.info(getMessage('cacheItemRequiresKey'), infoHeading, infoBold);
      }

      const appCache = cache[storageKey];
      return appCache ? appCache[key] || null : null;
    },
    removeCacheItem: (): CacheHelper => {
      const newCache: LoseObject = {};
      Object.keys(cache).forEach((k) => {
        if (storageKey !== k) {
          newCache[k] = cache[k];
        }
      });

      cache = newCache;
      saveToStorage();
      return cacheHelper;
    },
    clear: (): void => {
      if (storage && typeof window !== 'undefined') {
        storage.removeItem(storageKey);
      }
    },
  };

  return cacheHelper;
};
